import { default as baseTheme } from './base'
import { createTheme } from '@mui/material/styles'

// ----------------------------------------
// Brand Color
// ----------------------------------------
const brandColorSet = {
  main: '#f36f21',
  light: '#fff3e2',
  dark: '#e9541f',
  contrastText: '#fff'
}

const theme = createTheme(baseTheme, {
  palette: {
    type: 'light',
    brand: brandColorSet
  }
})

export default theme
